import React, { useState, useEffect } from 'react'
import MapView from '../MapView'
import Text from '../Text'
import Button from '../ButtonNew'
import SearchIcon from '../Icons/SearchIcon'
import LocationOutlinedIcon from '../Icons/LocationOutlinedIcon'
import AddressSearchModal from '../Modal/AddressSearchModal'
import { getAddressComponents } from '../../utils/helpers/common'

const defaultLocation = {
  lat: 37.4275,
  lng: -122.1697,
}

const AddressSelector = ({ onAddressSelect, onBack }) => {
  const [selectedLocation, setSelectedLocation] = useState(defaultLocation)
  const [address, setAddress] = useState('')
  const [showAddressSearch, setShowAddressSearch] = useState(false)

  const fetchAddress = async (location) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location.lat},${location.lng}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`,
      )
      const data = await response.json()
      if (data.results && data.results[0]) {
        console.log('data', data.results[0])
        // can we set here as pincode, houseNumber, street
        setAddress({
          ...getAddressComponents(data.results[0].address_components),
          formatted_address: data.results[0].formatted_address,
        })
      }
    } catch (error) {
      console.error('Error getting address:', error)
    }
  }

  useEffect(() => {
    // Fetch address for default location when component mounts
    fetchAddress(defaultLocation)
  }, [])

  const handleLocationSelect = async (location) => {
    console.log('location', location)
    setSelectedLocation(location)
    await fetchAddress(location)
  }

  const handleUseCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          handleLocationSelect({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          })
        },
        (error) => {
          console.error('Error getting location:', error)
        },
      )
    }
  }

  const handleContinue = () => {
    if (selectedLocation && address) {
      onAddressSelect({ location: selectedLocation, address })
    }
  }

  const handleAddressSelect = (address) => {
    console.log('address', address)
    setAddress(address?.formatted_address)
    handleLocationSelect({
      lat: address?.geometry?.location?.lat,
      lng: address?.geometry?.location?.lng,
    })
    setShowAddressSearch(false)
  }

  console.log('address', address)

  return (
    <div className="flex flex-col h-full">
      <div className="px-4 py-2">
        <Text variant="title" size="large" tag="p" className="text-[#1F2933]">
          Add Address
        </Text>
        <Text variant="body" size="medium" tag="p" className="text-[#5A6774]">
          Your <b>FREE</b> gel pack will be delivered to this address
        </Text>
      </div>

      <div className="relative mb-4">
        <button
          className="z-10 absolute left-4 right-4 top-4 bg-white shadow-lg border border-[#E5E7EB] rounded-lg px-4 py-2 flex items-center gap-2"
          onClick={() => setShowAddressSearch(true)}
        >
          <div>
            <SearchIcon />
          </div>
          <Text
            variant="body"
            size="medium"
            tag="p"
            className="ml-6 text-[#5A6774]"
          >
            Search for area, street name...
          </Text>
        </button>

        <div className="z-0 flex-1 relative h-[calc(100vh-40px-53px-65px-170px)] min-h-[300px]">
          <MapView
            provider={MapView.PROVIDER_GOOGLE}
            // style={{ height: '100%', minHeight: '400px' }}
            region={selectedLocation}
            onLocationSelect={handleLocationSelect}
            onRegionChange={handleLocationSelect}
            showsUserLocation={true}
            followsUserLocation={true}
            initialLocation={selectedLocation}
          />

          <button
            onClick={handleUseCurrentLocation}
            className="z-10 absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-white rounded-full px-2 py-1 shadow-lg flex items-center justify-center gap-3 border border-[#299D6B] min-w-[160px] whitespace-nowrap text-base"
          >
            <LocationOutlinedIcon color="#299D6B" />
            <Text
              variant="body"
              size="small"
              tag="p"
              className="text-[#299D6B]"
            >
              Use Current Location
            </Text>
          </button>
        </div>
      </div>

      {address && (
        <div className="p-4 border-t border-gray-200">
          <div className="flex items-start gap-3 mb-4">
            <LocationOutlinedIcon
              color="#299D6B"
              className="flex-shrink-0 mt-1"
            />
            <Text
              variant="body"
              size="medium"
              className="text-gray-800 line-clamp-2"
            >
              {address?.formatted_address}
            </Text>
          </div>

          <div className="flex gap-4">
            <Button
              fullWidth
              variant="outlined"
              onClick={onBack}
              className="flex-1"
            >
              Back
            </Button>
            <Button fullWidth onClick={handleContinue} className="flex-1">
              Continue
            </Button>
          </div>
        </div>
      )}

      {showAddressSearch && (
        <AddressSearchModal
          show={showAddressSearch}
          onClose={() => setShowAddressSearch(false)}
          onAddressSelect={handleAddressSelect}
        />
      )}
    </div>
  )
}

export default AddressSelector
